module.exports = __webpack_public_path__ + "img/daw.5eae60c4.svg";